/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */

/*
 * Disabled the following rules:
 * @typescript-eslint/naming-convention
 * @typescript-eslint/no-empty-interface
 * @typescript-eslint/no-unused-vars
 * sonarjs/no-duplicate-string
 * as MUI theme override required override interfaces.
 * Also, it has no sense to move out css variables into another variable
 *
 * More details on style overrides here https://mui.com/material-ui/customization/theme-components/#default-props
 */
import {ThemeOptions} from "@mui/material/styles";

export const componentsTheme: ThemeOptions = {
	components: {
		MuiIcon: {
			defaultProps: {
				color: "inherit",
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
					color: "#AEAEB2",
					fontSize: "12px",
					fontWeight: 400,
					lineHeight: "20px",
					letterSpacing: "0.4px",
				},
			},
		},
		MuiAccordion: {
			styleOverrides: {
				root: {
					background: "#000",
					color: "#fff",
					"&.Mui-expanded": {
						margin: 0,
						background: "#282F38",
					},
					"&.Mui-disabled": {
						margin: 0,
						color: "#fff",
						background: "#000",
					},
				},
			},
			variants: [
				{
					props: {className: "outlined"},
					style: {
						background: "transparent",
						borderBottom: "1px solid #fff",
						boxShadow: "none",
						"&.Mui-expanded": {
							margin: 0,
							background: "transparent",
							borderBottom: "none",
						},
						"&:before": {
							display: "none",
						},
					},
				},
			],
		},
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
					color: "#fff",
					borderRadius: 0,
					minHeight: "40px",
					"&.Mui-expanded": {
						minHeight: "40px",
					},
					"&.Mui-disabled": {
						opacity: 1,
					},
				},
				expandIconWrapper: {
					color: "#fff",
					".Mui-disabled &": {
						opacity: 0,
					},
				},
				content: {
					margin: 0,
					"&.Mui-expanded": {
						margin: 0,
					},
				},
			},
		},
		MuiAccordionDetails: {
			styleOverrides: {
				root: {
					padding: 0,
				},
			},
		},
	},
};
